import { Box } from "@material-ui/core";
import React from "react";
import Logo from "../../../Logo/Logo";
import { useWelcomeMessageStyle } from "../../hooks/useWelcomeMessageStyle";

export const WelcomeBackLogo = () => {
  const { logoHeight } = useWelcomeMessageStyle();
  return (
    <Box mt={2} display="flex" alignItems="center" justifyContent={"center"}>
      <Logo width={logoHeight * 1.8} height={logoHeight} />
    </Box>
  );
};
